(function() {
    'use strict';
    angular.module('emarket.commons').directive('emSocialButton', ['$state', '$auth', 'Auth', function($state, $auth, Auth) {
        return {
            scope: {
                network: '@'
            },
            link: function(scope, element) {
                element.on('click', function() {
                    $auth.authenticate(scope.network).then(function(response) {
                        var user = response.data.user;
                        Auth.setUser(user);
                        $state.go('main.home');
                    });
                });
            },
            templateUrl: 'directives/social-button/em-social-button.tpl.html'
        };
    }]);
}());
